import { AppDispatch } from '../../../../store';
import {
  fetchKfaQuestions,
  fetchObservationsQuestions,
  fetchObservationsQuestionsFilter,
  fetchRackingInspectionQuestions,
  fetchNhoQuestions,
  fetchSiteEvaluationQuestions,
} from '../../../../store/slices/adminSlice';
import { KfaTab, KfaFilterValues } from './kfaManagementConstants';

/**
 * Dispatches the correct fetch thunk for the active tab, applying all active
 * filter/search/pagination params. Extracted to keep KfaManagement.tsx lean.
 */
export const dispatchWithFilters = (
  dispatch: AppDispatch,
  activeKfaTab: KfaTab,
  page: number,
  size: number,
  filters: KfaFilterValues,
  search?: string,
) => {
  if (activeKfaTab === 'nho') {
    let statusParam: string | undefined;
    if (filters.status === 'Enabled') statusParam = 'true';
    else if (filters.status === 'Disabled') statusParam = 'false';
    let threePlParam: string | undefined;
    if (filters.thirdPartyStatus === 'Yes') threePlParam = 'YES';
    else if (filters.thirdPartyStatus === 'No') threePlParam = 'NO';
    dispatch(fetchNhoQuestions({
      page,
      size,
      ...(filters.locationType ? { locationType: filters.locationType } : {}),
      ...(filters.orgType ? { organizationType: filters.orgType } : {}),
      ...(threePlParam !== undefined ? { threePlStatus: threePlParam } : {}),
      ...(filters.category ? { category: filters.category } : {}),
      ...(statusParam !== undefined ? { status: statusParam } : {}),
      ...(search ? { search } : {}),
    }));
    return;
  }

  if (activeKfaTab === 'site-evaluation') {
    let statusParam: string | undefined;
    if (filters.status === 'Enabled') statusParam = 'true';
    else if (filters.status === 'Disabled') statusParam = 'false';
    let threePlParam: string | undefined;
    if (filters.thirdPartyStatus === 'Yes') threePlParam = 'YES';
    else if (filters.thirdPartyStatus === 'No') threePlParam = 'NO';
    dispatch(fetchSiteEvaluationQuestions({
      page,
      size,
      ...(filters.locationType ? { locationType: filters.locationType } : {}),
      ...(filters.orgType ? { orgType: filters.orgType } : {}),
      ...(threePlParam !== undefined ? { thirdPartyStatus: threePlParam } : {}),
      ...(filters.category ? { category: filters.category } : {}),
      ...(statusParam !== undefined ? { status: statusParam } : {}),
      ...(search ? { search } : {}),
    }));
    return;
  }

  if (activeKfaTab === 'observations') {
    let statusParam: string | undefined;
    if (filters.status === 'Enabled') statusParam = 'true';
    else if (filters.status === 'Disabled') statusParam = 'false';
    let is3plParam: string | undefined;
    if (filters.thirdPartyStatus === 'Yes') is3plParam = 'YES';
    else if (filters.thirdPartyStatus === 'No') is3plParam = 'NO';
    // Use the filter endpoint when any dropdown filter is actively selected;
    // fall back to the regular GET endpoint when all filters are cleared.
    const hasActiveFilters = !!(filters.locationType || filters.orgType || filters.thirdPartyStatus || filters.category || filters.status);
    if (hasActiveFilters) {
      dispatch(fetchObservationsQuestionsFilter({
        page,
        size,
        ...(filters.locationType ? { locationType: filters.locationType } : {}),
        ...(filters.orgType ? { orgType: filters.orgType } : {}),
        ...(is3plParam !== undefined ? { thirdPartyStatus: is3plParam } : {}),
        ...(filters.category ? { category: filters.category } : {}),
        ...(statusParam !== undefined ? { status: statusParam } : {}),
        ...(search ? { search } : {}),
      }));
    } else {
      dispatch(fetchObservationsQuestions({
        page,
        size,
        ...(search ? { search } : {}),
      }));
    }
    return;
  }

  if (activeKfaTab === 'racking-inspection') {
    let statusParam: string | undefined;
    if (filters.status === 'Enabled') statusParam = 'true';
    else if (filters.status === 'Disabled') statusParam = 'false';
    let threePlParam: string | undefined;
    if (filters.thirdPartyStatus === 'Yes') threePlParam = 'YES';
    else if (filters.thirdPartyStatus === 'No') threePlParam = 'NO';
    dispatch(fetchRackingInspectionQuestions({
      page,
      size,
      ...(filters.locationType ? { locationType: filters.locationType } : {}),
      ...(filters.orgType ? { organizationType: filters.orgType } : {}),
      ...(threePlParam !== undefined ? { threePlStatus: threePlParam } : {}),
      ...(filters.category ? { category: filters.category } : {}),
      ...(statusParam !== undefined ? { status: statusParam } : {}),
      ...(search ? { search } : {}),
    }));
    return;
  }

  // main tab → now split into shift-handover / leadership-walk / sparc-walk
  const MODULE_FOR_TAB: Record<string, string> = {
    'shift-handover': 'Shift Handover',
    'leadership-walk': 'Leadership Walk',
    'sparc-walk': 'SPARC Walk',
  };

  const singleModule = MODULE_FOR_TAB[activeKfaTab];
  if (singleModule) {
    let statusParam: string | undefined;
    if (filters.status === 'Enabled') statusParam = 'true';
    else if (filters.status === 'Disabled') statusParam = 'false';

    let is3plParam: string | undefined;
    if (filters.thirdPartyStatus === 'Yes') is3plParam = 'true';
    else if (filters.thirdPartyStatus === 'No') is3plParam = 'false';

    dispatch(fetchKfaQuestions({
      page,
      size,
      modules: [singleModule],
      ...(filters.locationType ? { locationType: filters.locationType } : {}),
      ...(filters.orgType ? { orgType: filters.orgType } : {}),
      ...(is3plParam !== undefined ? { thirdPartyStatus: is3plParam } : {}),
      ...(filters.category ? { sparcCategory: filters.category } : {}),
      ...(statusParam !== undefined ? { status: statusParam } : {}),
      ...(search ? { search } : {}),
    }));
    return;
  }
};
